import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type AIQuality = 'standard' | 'premium';

/** Maps quality tier to the actual OpenAI model ID sent to the server. */
export const AI_MODEL_MAP: Record<AIQuality, string> = {
  standard: 'gpt-5-mini',
  premium: 'gpt-5',
};

interface AIQualityState {
  quality: AIQuality;
  setQuality: (quality: AIQuality) => void;
}

export const useAIQualityStore = create<AIQualityState>()(
  persist(
    (set) => ({
      quality: 'standard',
      setQuality: (quality) => set({ quality }),
    }),
    { name: 'ai-quality' }
  )
);
